function pastEventPostListQueryModifier( query, postType, instanceId ) {
  if ( postType === 'events' && instanceId ) {
    // eslint-disable-next-line no-undef
    query['b3rg_post_list_query_name'] = _.snakeCase( instanceId );
  }
  return query;
}
  
( ( { hooks: { addFilter: addFilterBe } } ) => {
  addFilterBe(
    'b3rg_post_list_query',
    'b3rg/post-list',
    pastEventPostListQueryModifier
  );
  // eslint-disable-next-line no-undef
} )( wp );
  